import { Container, Row, Col, ListGroup, Table, Button, Modal } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import Card from '../components/Card'
import { useEffect, useState } from 'react'
import TempAccessForm from '../components/TempAccessForm'

export default function Access(props) {

    const user = useSelector(state => state.user)
    const accounts = useSelector(state => state.accounts)
    const stats = useSelector(state => state.stats)
    const filenames = useSelector(state => state.filenames)
    const [lastWeek, setLastWeek] = useState()
    const [show, setShow] = useState(false)
    const [tempAccess, setTempAccess] = useState([])

    var today = new Date()
    today.setDate(today.getDate() - 7)

    useEffect(() => {

        setLastWeek(today)
        var accessEvents = []
        for (const user of accounts) {

            accessEvents = [...accessEvents, ...user.tempAccess.map(ev => ({ ...ev, userId: user._id }))]
        }

        accessEvents.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        setTempAccess(accessEvents)

        document.title = 'ScamWall | Access Management'

    }, [accounts])

    return (
        <Container fluid className='pt-4 ps-4 m-0'>

            <h1 className='text-start'>Temporary Access</h1>
            <p className='text-start'>If one of your users needs legitimate access to programs, grant them temporary access here</p>
            <div className='text-end mb-2 me-3'>
                <Button onClick={() => setShow(true)}>Grant Access</Button>

            </div>


            <Table striped responsive className='border rounded'>
                <thead>
                    <tr>
                        <th>Program</th>
                        <th>User</th>
                        <th>Granted On</th>
                        <th>Expires</th>
                    </tr>
                </thead>
                <tbody>
                    {tempAccess.map(event => {
                        const filename = filenames?.find(name => name._id === event.fileNameId)
                        const user = accounts?.find(user => user._id === event.userId)
                        return (
                            <tr key={event._id}>
                                <td>{filename.displayName}</td>
                                <td>{user.fName} {user.lName}</td>
                                <td>{new Date(event.createdAt).toLocaleString('en-US', { timeStyle: 'short', dateStyle: 'short' })}</td>
                                <td>{new Date(event.expires).toLocaleString('en-US', { timeStyle: 'short', dateStyle: 'short' })}</td>
                            </tr>)
                    })}
                </tbody>

            </Table >

            {tempAccess.length === 0 && <p className='text-center'>You have not granted access to any programs.</p>}

            <Modal show={show} onHide={() => setShow(false)} size='md'>
                <Modal.Header closeButton>
                    <Modal.Title>Grant Temp Access</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <TempAccessForm close={() => setShow(false)} />
                </Modal.Body>

            </Modal>

        </Container >
    )
}